// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6661) return "static/chunks/6661-c5a26cd3048bf2c1.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"187":"aa776e4c","7849":"d886a1ee","9718":"d88bca72"}[chunkId] || chunkId) + "." + {"187":"9290f912b9c3b220","486":"7b735027724a3a3a","6195":"f03c8b0a92dc7746","7661":"38db386018e126bc","7849":"2422bddeafc5a165","9718":"51ce682f36ac4f99"}[chunkId] + ".js";
};